export default "__VITE_ASSET__DqDk3ao$__"